import "./Loader.scss"
import { FC } from "react"

const Loader: FC = () => {
  return (
    <div className="loader-overlay">
      <div className="loader"></div>
    </div>
  )
}

export default Loader
